import React, { useState } from "react";
import axios from "axios";
import { NavLink } from 'react-router-dom';
import "./Register.css";

const Register = () => {
    const [user, setUser] = useState({
        fname: "",
        lname: "",
        username: "",
        email: "",
        password: "",
        confirmPassword: "", // Added confirmPassword to state
        usertype: "user", // Default user type
    });

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false); // Added loading state for better UX

    const handleChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        if (!user.fname || !user.lname || !user.username || !user.email || !user.password || !user.confirmPassword) {
            setError("All fields are required.");
            return false;
        }
        if (!/\S+@\S+\.\S+/.test(user.email)) {
            setError("Please enter a valid email address.");
            return false;
        }
        if (user.password.length < 6) {
            setError("Password must be at least 6 characters long.");
            return false;
        }
        if (user.password !== user.confirmPassword) {
            setError("Passwords do not match.");
            return false;
        }
        return true;
    };

    const submitForm = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setError("");
        setMessage("");
        setLoading(true);

        try {
            const response = await axios.post("https://skcapi.btcjapan.co//register.php", {
                fname: user.fname,
                lname: user.lname,
                username: user.username,
                email: user.email,
                password: user.password,
                usertype: user.usertype,
            });

            if (response.data.Status === "201") {
                setMessage("Registration successful! Redirecting to login...");
                setUser({
                    fname: "",
                    lname: "",
                    username: "",
                    email: "",
                    password: "",
                    confirmPassword: "",
                    usertype: "user",
                });
                setTimeout(() => {
                    window.location.href = "/sign-in"; // Redirect to login page after 2 seconds
                }, 2000);
            } else {
                setError(response.data.Message || "Registration failed. Please try again.");
            }
        } catch (error) {
            console.error(error);
            setError("An error occurred. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="register-container">
            <div className="register-card">
                <h2 className="register-title">Register with SKC Japan</h2>
                <p className="register-subtitle">Create an account to explore our services</p>
                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
                <form className="register-form" onSubmit={submitForm}>
                    <div className="form-group">
                        <label htmlFor="fname">First Name</label>
                        <input
                            type="text"
                            id="fname"
                            name="fname"
                            placeholder="Enter your first name"
                            className="form-input"
                            value={user.fname}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="lname">Last Name</label>
                        <input
                            type="text"
                            id="lname"
                            name="lname"
                            placeholder="Enter your last name"
                            className="form-input"
                            value={user.lname}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            placeholder="Choose a username"
                            className="form-input"
                            value={user.username}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Enter your email"
                            className="form-input"
                            value={user.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Create a password"
                            className="form-input"
                            value={user.password}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirm-password">Confirm Password</label>
                        <input
                            type="password"
                            id="confirm-password"
                            name="confirmPassword"
                            placeholder="Confirm your password"
                            className="form-input"
                            value={user.confirmPassword}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <button type="submit" className="register-button" disabled={loading}>
                        {loading ? "Signing Up..." : "Sign Up"}
                    </button>
                </form>
                <p className="login-link">
                    Already have an account? <NavLink to="/sign-in" className="nav-link">Login here</NavLink>
                </p>
            </div>
        </div>
    );
};

export default Register;